import styled from 'styled-components';

export const StyledImageUploader = styled.div`
  width: 100%;
  height: 250px;

  background: rgba(245, 245, 248, 1);
  border-radius: 10px;

  padding: 8px;

  .upload-content {
    border: 1px dashed rgba(51, 61, 108, 0.1);
    background-color: transparent;
    border-radius: 10px;
    width: 100%;
    height: 100%;

    text-align: center;
    padding-left: 24px;
    padding-right: 24px;

    &__image {
      margin: 16px auto;
    }

    &__heading {
      margin-bottom: 8px;
      font-weight: 600;
      font-size: 14px;
      line-height: 14px;

      > button {
        font-size: 14px;
        line-height: 21px;
        font-weight: 600;
        color: #26bbd1;
        cursor: pointer;
        padding: 0;
        border-width: 0;
        background: transparent;

        &:hover {
          text-decoration-line: underline;
        }
      }
    }

    &__description {
      font-size: 12px;
      line-height: 18px;
    }

    &__upload-btn {
      cursor: pointer;
      margin: 0 auto 0 auto;
      border-width: 0;
      background-color: transparent;

      padding-top: 8px;
    }
  }

  .uploaded-image-content {
    position: relative;

    > img {
      display: block;
      width: 100%;
      height: 250px;
      border-radius: 10px;
      object-fit: cover;
    }

    > button {
      position: absolute;
      cursor: pointer;

      top: 15px;
      right: 15px;

      border-width: 0;
      background: transparent;

      > img {
        width: 30px;
        height: 30px;
      }
    }
  }
`;
